import { STRIEP_GATEWAY_EVENTS } from "repoV2/utils/payment/Stripe/Stripe.constants";

export const loadStripePaymentGateway = () => {
    const listenEv = new CustomEvent(STRIEP_GATEWAY_EVENTS.LOAD_STRIPE);
    document.dispatchEvent(listenEv);
};

export const STRIPE_FORM_RETURN_URL = `${process.env.NEXT_PUBLIC_API_URL}/payments/stripe/status`;
